import React, { useMemo } from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { formatCurrency, formatCompactCurrency } from '../../services/adminAnalyticsApi';

const CustomTooltip = ({ active, payload }) => {
  if (!active || !payload?.length) return null;
  const row = payload[0]?.payload;
  return (
    <div className="ab-card" style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem' }}>
      <p style={{ fontWeight: 600, margin: '0 0 0.25rem' }}>{row.name}</p>
      <p style={{ color: 'var(--ab-primary)', margin: '0.125rem 0' }}>Revenue: {formatCurrency(row.premium)}</p>
      <p style={{ fontSize: '0.75rem', color: 'var(--ab-muted-fg)', margin: '0.125rem 0' }}>{row.count} transactions</p>
    </div>
  );
};

const TopPerformingAgentsChart = ({ topAgents = [], title = 'Top Performing Agents', subtitle }) => {
  const data = useMemo(
    () => topAgents
      .map((row) => ({
        name: row.name || 'Unknown',
        premium: Number(row.premium) || 0,
        count: Number(row.count) || 0,
      }))
      .sort((a, b) => b.premium - a.premium)
      .slice(0, 6),
    [topAgents]
  );

  const subtitleText = subtitle || `Top ${Math.min(6, data.length)} agents by revenue`;

  return (
    <div className="ab-card">
      <div className="ab-card-header">
        <div>
          <h3 className="ab-card-title">{title}</h3>
          <p className="ab-page-subtitle">{subtitleText}</p>
        </div>
      </div>
      <div className="ab-card-body">
        <div style={{ height: 320 }}>
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={data} margin={{ top: 10, right: 8, left: 8, bottom: 36 }}>
              <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" vertical={false} />
              <XAxis
                dataKey="name"
                tick={{ fontSize: 10, fill: '#64748b' }}
                tickLine={false}
                axisLine={false}
                interval={0}
                height={48}
              />
              <YAxis
                tick={{ fontSize: 11, fill: '#64748b' }}
                tickLine={false}
                axisLine={false}
                tickFormatter={formatCompactCurrency}
              />
              <Tooltip content={<CustomTooltip />} />
              <Bar dataKey="premium" name="Revenue" fill="#1a2f5c" radius={[7, 7, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
};

export default TopPerformingAgentsChart;
